import { CRUD, CrudModel } from '../../classes'
import { PortalData } from './portal.data'
import { PortalSystem } from './portal-system'

@CRUD({
  base: '/crud/portal',
})
export class PortalModel extends CrudModel {
  public name!: string
  public portalSystemId!: string
  public portalSystem?: PortalSystem

  constructor(data: PortalData) {
    super(data, true)

    if (data.portalSystem) {
      this.portalSystem = data.portalSystem
    }
  }

  override toJSON() {
    return {
      ...super.toJSON(),
      name: this.name,
      portalSystemId: this.portalSystemId,
    }
  }
}
